import script from "./status-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./status-settings.vue?vue&type=script&setup=true&lang=js"

import "./status-settings.vue?vue&type=style&index=0&id=0df1f60e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df1f60e"]])

export default __exports__